import Header from "../../components/shared/Header";
import "../../styles/shared/Plans.scss";
// import HeroImage from "../../images/image 103.png";
import HeroImage from "../../images/basicFrame.png";
import SolutionImage1 from "../../images/realTimeTracking.png";
import SolutionImage2 from "../../images/CarbonIncentives(CCRTs).png";
import SolutionImage3 from "../../images/Carbonemissionrepor.png";
import SolutionImage4 from "../../images/verification.png";
import Focus from "../../images/potential.png";
import { useEffect, useState } from "react";
import GreenLogo from "../../images/Group 32.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../components/shared/Footer";
import BasicCollaborators from "../../components/shared/BasicCollaborators.jsx";
import NewFaq from "../../components/NewLandingPage/NewFaq.jsx";

export default function Basic() {
  const navigate = useNavigate();
  const [type, setType] = useState("tracking");
  const [planVideo, setplanVideo] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const nextBtn = document.querySelector(".feedback__inner__group__svg-group__next");
    const prevBtn = document.querySelector(".feedback__inner__group__svg-group__prev");
    const slider = document.querySelector(".feedback__inner__cards");
    const card = document.querySelector(".feedback__inner__cards__card");
    let itemDimensions = card.getBoundingClientRect();
    let amountToSlide = (itemDimensions.width + 24) * 3;

    nextBtn.addEventListener("click", () => {
      slider.scrollLeft += amountToSlide;
      console.log(
        'nextBtn', nextBtn,
        'prevBtn', prevBtn,
        'slider', slider,
        'card', card,
        'itemDimensions', itemDimensions,
        'amountToSlide', amountToSlide
      );
    });

    prevBtn.addEventListener("click", () => {
      slider.scrollLeft -= amountToSlide;
    });

  }, [])

  return (
    <div className="plans">
      <Header />
      <div className="hero">
        <div className="hero__inner">
          <div className="hero__inner__title">
            CloseCarbon <span>Basic</span>
          </div>
          <div className="hero__inner__subtitle">
            Real-time emission reduction. Set new goals. Carbon incentives.
            Validation. Verification. Monitoring. Free Internet of Things (IoT) devices.
          </div>
          <div className="hero__inner__price">
            Starting at ₦0 <span>Free</span>
          </div>
          <div className="hero__inner__button-group">
            <button
              onClick={() => navigate('/template/basic')}
            >Choose plan</button>
            <button
              onClick={() => {
                window.open("https://youtu.be/yyxGaFNoDws?si=CYUdV1gbyQ6IJxyz", "_blank", "noopener,noreferrer");
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.155 13.7501C3.96313 13.7497 3.77466 13.6994 3.60812 13.6041C3.23312 13.3916 3 12.9791 3 12.5313V3.46881C3 3.01974 3.23312 2.60849 3.60812 2.39599C3.77863 2.298 3.97232 2.24761 4.16896 2.25009C4.36559 2.25256 4.55796 2.30781 4.72594 2.41006L12.4712 7.04631C12.6327 7.14752 12.7657 7.28807 12.858 7.45479C12.9502 7.6215 12.9986 7.8089 12.9986 7.99943C12.9986 8.18996 12.9502 8.37736 12.858 8.54408C12.7657 8.71079 12.6327 8.85134 12.4712 8.95256L4.72469 13.5901C4.55278 13.694 4.35588 13.7493 4.155 13.7501Z"
                  fill="#0FA958"
                />
              </svg>
              Watch now
            </button>
          </div>

          <img className="hero__inner__img" src={HeroImage} alt="" loading="lazy" />
        </div>
      </div>
      <div className="solution">
        <div className="solution__title">
          The <span>solution</span> you need for the sustainability <br></br> you want
        </div>
        <div className="solution__subtitle">
          A seamless user experience, an intuitive dashboard, and innovative
          features that keep you aligned with your sustainability goals{" "} <br />
          {/* <span>- LeadGravel</span> */}
        </div>
        <div className="solution__grid">
          <div className="solution__grid__nav">
            <div
              className={
                type === "tracking"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("tracking")}
            >
              <div className="solution__grid__nav__item__title">
                Real-time tracking
              </div>
              {type === "tracking" && (
                <div className="solution__grid__nav__item__subtitle">
Track your carbon emissions effortlessly through IoT-enabled data capture and intelligent dashboards. Monitor performance, set reduction goals, and measure progress toward your sustainability targets                </div>
              )}
            </div>
            <div
              className={
                type === "credit"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("credit")}
            >
              <div className="solution__grid__nav__item__title">
Carbon Incentives (CCRTs)
              </div>
              {type === "credit" && (
                <div className="solution__grid__nav__item__subtitle">
Earn CloseCarbon Reduction Tonnes (CCRTs) for every verified tonne of CO₂ or CO₂e reduced. Your measurable climate action is transformed into transparent, traceable carbon assets. 
                </div>
              )}
            </div>
            <div
              className={
                type === "verification"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("verification")}
            >
              <div className="solution__grid__nav__item__title">
Verification
              </div>
              {type === "verification" && (
                <div className="solution__grid__nav__item__subtitle">
Generate comprehensive, downloadable carbon emissions reports. Maintain transparency, track performance over time, and support compliance with sustainability and corporate reporting goals. 
                </div>
              )}
            </div>
            <div
              className={
                type === "insights"
                  ? "solution__grid__nav__item solution__grid__nav__item-active"
                  : "solution__grid__nav__item"
              }
              onClick={() => setType("insights")}
            >
              <div className="solution__grid__nav__item__title">
Get insights through informative reports              </div>
              {type === "insights" && (
                <div className="solution__grid__nav__item__subtitle">
Your emissions data is independently reviewed by certified verifiers to ensure accuracy, reliability, and compliance with recognized carbon methodologies and standards. 
                </div>
              )}
            </div>
          </div>
          {type === "tracking" && (
            <img src={SolutionImage1} className="solution__grid__img" loading="lazy" />
          )}
          {type === "credit" && (
            <img src={SolutionImage2} className="solution__grid__img" loading="lazy" />
          )}
          {type === "verification" && (
            <img src={SolutionImage3} className="solution__grid__img" loading="lazy" />
          )}
          {type === "insights" && (
            <img src={SolutionImage4} className="solution__grid__img" loading="lazy" />
          )}
        </div>
      </div>
      <div className="feedback">
        <div className="feedback__inner">
          <div className="feedback__inner__group">
            <div className="feedback__inner__group__title">
              Feedback from our customers
            </div>
            <div className="feedback__inner__group__subtitle">
We’re trusted by several organizations
            </div>
            <div className="feedback__inner__group__svg-group">
              <div className="feedback__inner__group__svg-group__prev">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM17 7L1 7V9L17 9V7Z" />
                </svg>
              </div>

              <div className="feedback__inner__group__svg-group__next">
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.7071 8.70711C17.0976 8.31658 17.0976 7.68342 16.7071 7.29289L10.3431 0.928932C9.95262 0.538408 9.31946 0.538408 8.92893 0.928932C8.53841 1.31946 8.53841 1.95262 8.92893 2.34315L14.5858 8L8.92893 13.6569C8.53841 14.0474 8.53841 14.6805 8.92893 15.0711C9.31946 15.4616 9.95262 15.4616 10.3431 15.0711L16.7071 8.70711ZM0 9H16V7H0L0 9Z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="feedback__inner__cards">
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
This plan was the best fit for our organization. It connected us with a verifier and ensured our reports were valid and credible. It’s a full package for companies aiming for verified sustainability progress.
                      </div>
              <div className="feedback__inner__cards__card__subtitle">
          Temi Balogun
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
We needed a plan that supports both emission tracking and proper documentation. The Business Plan gave us that and more. It streamlined our compliance and saved us valuable time.                    </div>
              <div className="feedback__inner__cards__card__subtitle">
Nathan Moreau
              </div>
              <div></div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
The Business Plan helped us automate our reporting and get our carbon monitoring certificate with ease. Having a sub-verifier assigned gave us confidence in the process. It’s ideal for facilities that want structured support.
                 </div>
              <div className="feedback__inner__cards__card__subtitle">
 Elena Strauss
               </div>
              <div></div>
            </div>
            {/* <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              CloseCarbon's basic plan made it incredibly easy for me to track my carbon emissions. I'm impressed with the simplicity and effectiveness of the tools provided.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              I've been using CloseCarbon's basic plan for a month now, and I'm already seeing positive changes in my carbon footprint. The real-time tracking feature is especially helpful in keeping me accountable.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div>
            <div className="feedback__inner__cards__card">
              <div className="feedback__inner__cards__card__cover"></div>

              <div className="feedback__inner__cards__card__title">
              This basic plan makes me feel more empowered to make sustainable choices in my daily life. The user-friendly interface have been instrumental in guiding me towards a greener lifestyle.
              </div>
              <div className="feedback__inner__cards__card__subtitle">
                Samuel
              </div>
              <div>LS Truval</div>
            </div> */}

          </div>
        </div>
      </div>

      <div className="unlock">
        <div className="unlock__card1">
          <div className="unlock__card1__title font-bold">
Unlock the potential of <span className="text-[#0D924F]">CloseCarbon Basic plan</span> 
          </div>
          <div className="unlock__card1__subtitle">
       Empower your sustainability journey with the option to engage Third-party Bodies to review and approve your emissions data. These  bodies (SUB-CCVs) provide an added layer of credibility to your emissions monitoring efforts. 
          </div>
          <img className="unlock__card1__img" src={Focus} alt="" loading="lazy" />
        </div>
        <div className="unlock__card2">
          <div className="unlock__card2__flex">

            <img src={GreenLogo} loading="lazy" />
            <div>
              <div>Basic</div>

              <div>
                Green project (solar, renewable energy...) <br />
             Non- green project (infrastructure change & monitoring)
              </div>
              <div>  
             



             
            </div>
             

              </div>
                  <div >
                 <div className="text-[#0D924F] text-6xl font-bold ml-20">    ₦ 0</div>
            <div className="ml-40 text-gray-500">Free</div>

                  </div>

                  

             <div>

              </div>
          </div>
          {/* <div className="unlock__card2__divider"></div> */}
          <div className="unlock__card2__price">
          
          </div>
          <div className="unlock__card2__divider"></div>
          <div className="unlock__card2__more-info">
            <div className="unlock__card2__more-info__title">Access to:</div>
            <div className="unlock__card2__more-info__flex pr-3">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M7.21777 6.59961H18.7734C19.5126 6.59961 20.1181 7.20517 20.1182 7.94434V18.0557C20.1181 18.7948 19.5126 19.4004 18.7734 19.4004H7.21777C6.47864 19.4003 5.87311 18.7948 5.87305 18.0557V7.94434C5.87311 7.20521 6.47864 6.59967 7.21777 6.59961ZM7.11816 18.1553H18.873V7.84473H7.11816V18.1553Z" fill="#475367" stroke="#F0F2F5" stroke-width="0.2"/>
<path d="M11.4482 15.2666V16.5107H8.03711V15.2666H11.4482ZM18.2031 11.8584L15.0293 15.0244L13.1338 13.1152L14.0107 12.2383L14.959 13.1934L15.0293 13.2646L15.1006 13.1934L17.3184 10.9746L18.2031 11.8584ZM11.4482 12.3779V13.6221H8.03711V12.3779H11.4482ZM11.4482 9.48828V10.7334H8.03711V9.48828H11.4482Z" fill="#475367" stroke="#F0F2F5" stroke-width="0.2"/>
</svg>


              <div>
                Validation: We rigorously assess the accuracy of assumptions and methodologies to ensure that your future sustainability activities yield reliable outcomes.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
             <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<g clip-path="url(#clip0_6021_20285)">
<path d="M15.7057 11.375L12.8306 15.2086C12.784 15.2706 12.7246 15.3219 12.6565 15.359C12.5884 15.3961 12.5131 15.4181 12.4357 15.4236C12.3583 15.4291 12.2807 15.4179 12.208 15.3907C12.1353 15.3636 12.0693 15.3212 12.0145 15.2663L10.2891 13.5417" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.0787 5.31428C12.1891 5.17715 12.3287 5.06651 12.4875 4.99049C12.6462 4.91446 12.82 4.875 12.996 4.875C13.172 4.875 13.3457 4.91446 13.5045 4.99049C13.6632 5.06651 13.8029 5.17715 13.9132 5.31428L15.0052 6.67278C15.1289 6.82685 15.2894 6.9473 15.4719 7.02303C15.6544 7.09876 15.8531 7.12734 16.0495 7.10612L17.7829 6.91762C17.9583 6.89812 18.1359 6.91835 18.3025 6.97679C18.4691 7.03522 18.6204 7.13038 18.7453 7.25522C18.8701 7.38005 18.9653 7.53137 19.0237 7.69796C19.0821 7.86455 19.1024 8.04215 19.0829 8.21762L18.8944 9.95095C18.8731 10.1474 18.9017 10.346 18.9774 10.5285C19.0532 10.7111 19.1736 10.8716 19.3277 10.9953L20.6862 12.0873C20.8233 12.1976 20.934 12.3373 21.01 12.496C21.086 12.6547 21.1255 12.8285 21.1255 13.0045C21.1255 13.1805 21.086 13.3543 21.01 13.513C20.934 13.6717 20.8233 13.8114 20.6862 13.9217L19.3234 15.0087C19.1692 15.1325 19.0487 15.2931 18.9729 15.4757C18.8972 15.6584 18.8687 15.8572 18.89 16.0537L19.0785 17.7871C19.098 17.9625 19.0778 18.1401 19.0194 18.3067C18.9609 18.4733 18.8658 18.6246 18.7409 18.7495C18.6161 18.8743 18.4648 18.9695 18.2982 19.0279C18.1316 19.0863 17.954 19.1066 17.7785 19.0871L16.0452 18.8986C15.8487 18.8773 15.6501 18.9059 15.4676 18.9816C15.2851 19.0574 15.1246 19.1778 15.0009 19.3319L13.9132 20.6853C13.8029 20.8225 13.6632 20.9331 13.5045 21.0091C13.3457 21.0852 13.172 21.1246 12.996 21.1246C12.82 21.1246 12.6462 21.0852 12.4875 21.0091C12.3287 20.9331 12.1891 20.8225 12.0787 20.6853L10.9875 19.3276C10.8637 19.1734 10.7031 19.0529 10.5204 18.9771C10.3378 18.9014 10.139 18.8729 9.94241 18.8942L8.20908 19.0827C8.03353 19.1026 7.85575 19.0827 7.68896 19.0244C7.52218 18.9661 7.37069 18.871 7.24576 18.746C7.12083 18.6211 7.02568 18.4696 6.96739 18.3028C6.9091 18.1361 6.88917 17.9583 6.90908 17.7827L7.09758 16.0494C7.11893 15.8528 7.09042 15.654 7.01468 15.4714C6.93895 15.2888 6.81843 15.1281 6.66425 15.0043L5.30647 13.9131C5.16934 13.8027 5.05869 13.6631 4.98267 13.5043C4.90665 13.3456 4.86719 13.1718 4.86719 12.9958C4.86719 12.8198 4.90665 12.6461 4.98267 12.4873C5.05869 12.3286 5.16934 12.1889 5.30647 12.0786L6.66425 10.9866C6.81832 10.8629 6.93877 10.7024 7.0145 10.5199C7.09023 10.3374 7.1188 10.1387 7.09758 9.94228L6.90908 8.20895C6.88959 8.03348 6.90981 7.85588 6.96825 7.68929C7.02669 7.5227 7.12185 7.37139 7.24668 7.24655C7.37152 7.12172 7.52283 7.02656 7.68942 6.96812C7.85601 6.90968 8.03362 6.88946 8.20908 6.90895L9.94241 7.09745C10.139 7.11879 10.3378 7.09028 10.5204 7.01455C10.7031 6.93882 10.8637 6.8183 10.9875 6.66412L12.0787 5.31428Z" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_6021_20285">
<rect width="17.3333" height="17.3333" fill="white" transform="translate(4.32812 4.33398)"/>
</clipPath>
</defs>
</svg>


              <div>
                Verification: Your carbon reduction data is thoroughly reviewed to confirm it meets established industry standards.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex">
              <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M19.451 16.4917C19.0552 14.129 17.9239 11.9514 16.2183 10.2691C15.845 9.90578 15.6586 9.72451 15.2462 9.55695C14.8338 9.38867 14.4792 9.38867 13.7707 9.38867H12.2136C11.5051 9.38867 11.1505 9.38867 10.7381 9.55695C10.3265 9.72451 10.1387 9.90578 9.76601 10.2691C8.06045 11.9514 6.92919 14.129 6.53334 16.4917C6.18162 18.6136 8.13884 20.222 10.3257 20.222H15.6586C17.8462 20.222 19.8042 18.6136 19.4503 16.4917" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.56856 7.54173C9.41906 7.32507 9.20311 7.0304 9.64944 6.96395C10.1081 6.89462 10.584 7.20807 11.0506 7.20229C11.4716 7.19579 11.6861 7.00873 11.9172 6.74151C12.1599 6.46057 12.5354 5.77734 12.9941 5.77734C13.4527 5.77734 13.8282 6.46057 14.0709 6.74151C14.302 7.00873 14.5165 7.19651 14.9376 7.20157C15.4041 7.20879 15.8801 6.89462 16.3387 6.96323C16.785 7.0304 16.5691 7.32434 16.4196 7.54101L15.7464 8.52251C15.4576 8.9414 15.3138 9.15084 15.0119 9.27001C14.7101 9.38918 14.3208 9.38846 13.5415 9.38846H12.4466C11.6666 9.38846 11.2773 9.38846 10.9762 9.27001C10.675 9.15157 10.5306 8.94068 10.2417 8.52179L9.56856 7.54173Z" stroke="#475367" stroke-width="1.08333" stroke-linejoin="round"/>
<path d="M14.1674 13.6632C14.0114 13.0862 13.2162 12.5662 12.2621 12.9554C11.3081 13.3447 11.1571 14.5963 12.5994 14.7299C13.2523 14.7899 13.677 14.6599 14.0663 15.0275C14.4563 15.3944 14.5285 16.4163 13.5325 16.6915C12.538 16.9667 11.5522 16.5369 11.4453 15.9259M12.8782 12.2715V12.8211M12.8782 16.776V17.3278" stroke="#475367" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


              <div>
                Tangible Proof: Receive CloseCarbon credits—officially verified and issued by regulatory bodies—as concrete evidence of your carbon emissions reductions.
              </div>
            </div>
            <div className="unlock__card2__more-info__flex ">
              <svg width="26" height="26"  viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="13" cy="13" r="13" fill="#F0F2F5"/>
<path d="M19.4974 12.998V16.248H6.4974V7.58138H10.2891V6.49805H6.4974C6.21008 6.49805 5.93453 6.61218 5.73136 6.81535C5.5282 7.01851 5.41406 7.29406 5.41406 7.58138V16.248C5.41406 16.5354 5.5282 16.8109 5.73136 17.0141C5.93453 17.2172 6.21008 17.3314 6.4974 17.3314H10.8307V19.498H8.66406V20.5814H17.3307V19.498H15.1641V17.3314H19.4974C19.7847 17.3314 20.0603 17.2172 20.2634 17.0141C20.4666 16.8109 20.5807 16.5354 20.5807 16.248V12.998H19.4974ZM14.0807 19.498H11.9141V17.3314H14.0807V19.498Z" fill="#475367"/>
<path d="M14.0807 14.0821H14.0753C13.9586 14.0809 13.8454 14.042 13.7526 13.9712C13.6598 13.9005 13.5923 13.8016 13.5602 13.6894L12.589 10.2904H10.2891V9.20709H12.9974C13.1151 9.20703 13.2297 9.24532 13.3237 9.31618C13.4177 9.38704 13.4861 9.4866 13.5185 9.5998L14.1002 11.6365L15.7301 6.33897C15.765 6.22886 15.8338 6.13261 15.9267 6.06402C16.0197 5.99542 16.1319 5.95799 16.2474 5.95709C16.3615 5.95538 16.4732 5.99049 16.5658 6.05723C16.6584 6.12397 16.727 6.21878 16.7614 6.32759L17.7207 9.20709H20.5807V10.2904H17.3307C17.217 10.2905 17.1061 10.2547 17.0139 10.1882C16.9216 10.1217 16.8526 10.0278 16.8167 9.91992L16.268 8.27326L14.5986 13.6997C14.5645 13.8104 14.4958 13.9073 14.4026 13.9762C14.3094 14.045 14.1966 14.0821 14.0807 14.0821Z" fill="#475367"/>
</svg>


              <div>
              Set Effortless Monitoring: Track your carbon emissions with ease. Our real-time monitoring provides actionable insights, empowering you to measure progress and make informed, sustainable decisions.
              </div>
            </div>

            <button
              className="hero-btn group text-[16px] text-white flex justify-center items-center border-2 border-[#E4E7EC] py-[6px] gap-[10px] w-[193px]  h-[56px] bg-[#0D924F] rounded-xl hover:bg-[#0d713f] transition-all cursor-pointer  hover:-translate-y-0.5 "
              onClick={() => navigate('/template/basic')}
            >
              Choose plan
            </button>
          </div>
        </div>
      </div>
      <div className="bg-[#D3EEE0]">
<NewFaq/>

      </div>
      {/* <div className="faq">
        <div className="faq__inner">
          <div className="faq__inner__card1">
            <div className="faq__inner__card1__title">
              Frequently <br /> Asked <br /> <span>Questions</span>
            </div>
          </div>
          <div className="faq__inner__card2">
            <div
              className="faq__inner__card2__faq-card"
              onClick={() => (openFaq === 0 ? setOpenFaq(null) : setOpenFaq(0))}
            >
              <div className="card_inner">
                <div>What features are included in the basic plan?</div>
                <div className="plus">
                  <div className="item"></div>
                  <div
                    className={
                      openFaq === 0 ? "item item2 itemOpaque" : "item item2"
                    }
                  ></div>
                </div>
              </div>
              <div>
                {openFaq === 0 && (
                  <div className="subtitle">
                    Closecarbon's Basic plan offers essential tools for monitoring carbon emissions, setting reduction goals, and accessing basic verification services. Users can track their carbon emissions in real-time, receive customizable reports, and access a simplified verification process.
                  </div>
                )}
                <div className="line"></div>
              </div>
            </div>
            <div
              className="faq__inner__card2__faq-card"
              onClick={() => (openFaq === 1 ? setOpenFaq(null) : setOpenFaq(1))}
            >
              <div className="card_inner">
                <div>
                  How accurate is the carbon tracking feature in the Basic Plan?
                </div>
                <div className="plus">
                  <div className="item"></div>
                  <div
                    className={
                      openFaq === 1 ? "item item2 itemOpaque" : "item item2"
                    }
                  ></div>
                </div>
              </div>
              <div>
                {openFaq === 1 && (
                  <div className="subtitle">
                    The Basic Plan uses standard emission factors and real-time usage data to provide reasonably accurate tracking, suitable for internal monitoring and early-stage sustainability planning
                  </div>
                )}
                <div className="line"></div>
              </div>
            </div>
            <div
              className="faq__inner__card2__faq-card"
              onClick={() => (openFaq === 2 ? setOpenFaq(null) : setOpenFaq(2))}
            >
              <div className="card_inner">
                <div>
                  Is there a limit to the number of emissions I can track with the Basic Plan?
                </div>
                <div className="plus">
                  <div className="item"></div>
                  <div
                    className={
                      openFaq === 2 ? "item item2 itemOpaque" : "item item2"
                    }
                  ></div>
                </div>
              </div>
              <div>
                {openFaq === 2 && (
                  <div className="subtitle">
                    Yes. The Basic Plan is intended for single-facility use and may have limits on the number of emission sources you can monitor. For broader or multi-site tracking, an upgrade may be required.
                  </div>
                )}
                <div className="line"></div>
              </div>
            </div>
            <div
              className="faq__inner__card2__faq-card"
              onClick={() => (openFaq === 3 ? setOpenFaq(null) : setOpenFaq(3))}
            >
              <div className="card_inner">
                <div>
                  Can I set and monitor carbon reduction goals with this plan?
                </div>
                <div className="plus">
                  <div className="item"></div>
                  <div
                    className={
                      openFaq === 3 ? "item item2 itemOpaque" : "item item2"
                    }
                  ></div>
                </div>
              </div>
              <div>
                {openFaq === 3 && (
                  <div className="subtitle">
                    Yes. The Basic Plan allows you to set personalized emission reduction targets and track your progress against them over time
                  </div>
                )}
                <div className="line"></div>
              </div>
            </div>
            <div
              className="faq__inner__card2__faq-card"
              onClick={() => (openFaq === 4 ? setOpenFaq(null) : setOpenFaq(4))}
            >
              <div className="card_inner">
                <div>
                  Can I download a carbon report or certificate on the Basic Plan?
                </div>
                <div className="plus">
                  <div className="item"></div>
                  <div
                    className={
                      openFaq === 4 ? "item item2 itemOpaque" : "item item2"
                    }
                  ></div>
                </div>
              </div>
              <div>
                {openFaq === 4 && (
                  <div className="subtitle">
                    No. The Basic Plan does not include access to downloadable carbon emission reports or certificates. These features are available in higher-tier plans like business and business plus plan.
                  </div>
                )}
                <div className="line"></div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <BasicCollaborators />
      <Footer />

    </div>
  );
}
